import { ChevronRightIcon, ChevronUpIcon, XIcon } from "@primer/octicons-react";
import { Box, IconButton } from "@primer/react";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { thuPhiApi } from "../../../api/thuPhiApi";
import { DefaultConfirm } from "../../../components/confirm";
import { DefaultPopup } from "../../../components/modal";
import { PlaceHolder } from "../../../components/place-holder";
import ThuPhiAddKhoanNopBtn from "../../../components/thu-phi/add-khoan-nop";
import ThuPhiDieuChinhChietKhauBtn from "../../../components/thu-phi/dieu-chinh-chiet-khau";
import ThuPhiFinishConfirmBtn from "../../../components/thu-phi/finish-confirm";
import ThuPhiHuyChungTuBtn from "../../../components/thu-phi/huy-chung-tu";
import ThuPhiSendBienLaiBtn from "../../../components/thu-phi/send-bien-lai";
import ThuPhiTaoBienLaiBtn from "../../../components/thu-phi/tao-bien-lai";
import ThuPhiThongTinTongHop from "../../../components/thu-phi/thong-tin-tong-hop";
import Button from "../../../components/ui/button";
import DataTable, {
  IColumn,
} from "../../../components/ui/data-table/DataTable";
import ModalActions from "../../../components/ui/modal/ModalActions";
import { useCommonContext } from "../../../contexts/common";
import { showNotify } from "../../../helpers/toast";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import { sf_mucphaithu_chitiet_viewmodel } from "../../../models/response/thu-phi/sf_mucphaithu_chitiet";
import {
  closeThuPhiDeleteKhoanNopConfirm,
  deleteThuPhiKhoanNopStart,
  initialThuPhiChiTietState,
  loadThuPhiChiTietMucPhaiThuStart,
  loadThuPhiChiTietStart,
  loadThuPhiMienGiamStart,
  loadThuPhiPhanBoPhiStart,
  showThuPhiDeleteKhoanNopConfirm,
} from "../../../state/actions/thuPhiChiTietAction";
import { RootState } from "../../../state/reducers";
import { formatVND } from "../../../utils/formatVND";
import HoanPhiQuyetToanBtn from "../hoanphi-quyettoan-btn";
import "./thu-phi-chi-tiet.scss";

interface ISummaryItem {
  name: string;
  column: string;
  summaryType: "sum" | "custom";
  render: (value: number) => string | JSX.Element;
}

interface ISummary {
  calculateCustomSummary?: (column: string, data: any[]) => number;
  items: ISummaryItem[];
}

type ThuPhiChiTietProps = {
  sf_mucphaithu: sf_mucphaithu;
  animationOf: string;
  onClose: (isMustReload: boolean) => void;
  ts_hocsinh: any;
  nam_hoc: string;
};

const ThuPhiChiTiet = (props: ThuPhiChiTietProps) => {
  const [isShowPlaceHolder, SetIsShowPlaceHolder] = useState<boolean>(false);
  const [isLoadBienLai, setIsLoadBienLai] = useState<boolean>(false);
  const { createUUID } = useCommonContext();
  const [bienlaithu, set_bienlaithu] = useState<any[] | undefined>(undefined);
  const [ngaythu, set_ngaythu] = useState<any>(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [namhoc_dongphi, set_namhoc_dongphi] = useState<string>(
    props.nam_hoc || "2025-2026"
  );
  const [tong_tien_thua, set_tong_tien_thua] = useState<any>(0);
  const [tong_tien_da_nop_custom, set_tong_tien_da_nop_custom] =
    useState<any>(0);
  const [expandedGroups, setExpandedGroups] = useState<Map<string, string>>(
    new Map()
  );

  const state = useSelector((x: RootState) => x.thuPhiChiTiet);
  const [mucphaithu, set_mucphaithu] = useState<any | undefined>(undefined);
  const [mucphaithu_chitiet, set_mucphaithu_chitiet] = useState<
    any | undefined
  >(undefined);
  const { dm_coso_id } = useSelector((x: RootState) => x.common);

  const dispatch = useDispatch();
  const {
    is_show_confirm_delete,
    sf_mucphaithu_miengiams,
    sf_mucphaithu,
    sf_mucphaithu_chitiet_miengiams,
    sf_mucphaithu_chitiet_selected,
    sf_mucphaithu_chitiets,
    sf_phanbophis,
    status,
  } = state;
  const isAccessibleDelete: boolean = true;
  const is_readOnly =
    sf_mucphaithu &&
    (sf_mucphaithu?.tong_tien_da_nop > 0 ||
      sf_mucphaithu?.sf_hachtoan_congno_id > 0 ||
      sf_mucphaithu?.so_chung_tu.includes("RV"));
  const is_tbtp = sf_mucphaithu && sf_mucphaithu?.sf_tbtp_id > 0;
  const is_khoanno =
    sf_mucphaithu !== null &&
    sf_mucphaithu !== undefined &&
    sf_mucphaithu.noi_dung &&
    sf_mucphaithu.noi_dung.toUpperCase().includes("KHOẢN NỢ");
  const is_tienmat =
    sf_phanbophis !== null &&
    sf_phanbophis !== undefined &&
    sf_phanbophis.length > 0 &&
    sf_phanbophis[0]?.hinh_thuc_thanh_toan?.toUpperCase().includes("TIỀN MẶT");
  const isVisibleDateBox =
    dm_coso_id === 2 || dm_coso_id === 8 || dm_coso_id === 10;
  const isHideDatbox =
    bienlaithu !== undefined && bienlaithu.length > 0 && is_tienmat;

  const currentDate = new Date();
  const dateToCheck = new Date(
    bienlaithu !== undefined && bienlaithu.length > 0 && bienlaithu[0].ngay_thu
  );
  const isDateInCurrentMonth =
    dateToCheck.getMonth() === currentDate.getMonth() &&
    dateToCheck.getFullYear() === currentDate.getFullYear();
  const phieu_thu_trong_thang = isDateInCurrentMonth;
  useEffect(() => {
    if (
      sf_phanbophis !== undefined &&
      sf_phanbophis !== null &&
      sf_phanbophis.length > 0 &&
      sf_phanbophis[0]?.so_chung_tu !== null
    ) {
      set_namhoc_dongphi(
        sf_phanbophis[0]?.nam_hoc_dong_phi == undefined
          ? props.nam_hoc
          : sf_phanbophis[0]?.nam_hoc_dong_phi
      );
      loadBienLai();
    }
  }, [sf_phanbophis, isLoadBienLai]);

  useEffect(() => {
    set_mucphaithu_chitiet(sf_mucphaithu_chitiets);
    handleReloadTienThuaHocSinh();
  }, [status]);
  // useEffect(() => {
  //   loadMucPhaiThu();
  // }, [state]);
  const loadBienLai = async () => {
    if (
      sf_phanbophis !== undefined &&
      sf_phanbophis !== null &&
      sf_phanbophis[0]?.so_chung_tu !== null &&
      sf_phanbophis[0]?.so_chung_tu.length > 0
    ) {
      var res = await bienLaiThuApi.get_by_chungtu(
        props.sf_mucphaithu.so_chung_tu == null
          ? sf_phanbophis[0]?.so_chung_tu
          : props.sf_mucphaithu.so_chung_tu
      );
      if (res.is_success) {
        if (res.data.length > 0) {
          set_ngaythu(res.data[0].ngay_thu_thuc_te);
        }
        set_bienlaithu(res.data);
        setIsLoadBienLai(false);
      }
    }
  };
  const loadMucPhaiThu = async () => {
    const request: sf_mucphaithu_select_byhocsinh_rq = {
      nam_hoc: props.nam_hoc,
      ts_hocsinh_id: props.ts_hocsinh.id,
    };
    var res = await mucPhaiThuApi.select_by_hocsinh(request);
    if (res.is_success) {
      set_mucphaithu(
        res.data.filter(
          (x: any) => x.so_chung_tu === props.sf_mucphaithu.so_chung_tu
        )[0]
      );
    }
  };
  const loadMucPhaiThuChiTiet = async () => {
    var res = await thuPhiApi.select_chitiet(props.sf_mucphaithu.id);
    if (res.is_success) {
      set_mucphaithu_chitiet(res.data);
    }
  };
  const handleReloadTienThuaHocSinh = async () => {
    const datasend: sf_mucphaithu_select_byhocsinh_rq = {
      ts_hocsinh_id: props.ts_hocsinh.id,
      nam_hoc: props.nam_hoc,
    };
    const res = await mucPhaiThuApi.select_tienthua_by_hocsinh(datasend);
    if (res.is_success && res.data && res.data.tong_tien_thua != undefined) {
      set_tong_tien_thua(res.data.tong_tien_thua);
    }
  };
  const rawDataSource = useMemo(() => {
    if (
      mucphaithu_chitiet &&
      sf_mucphaithu_miengiams &&
      sf_mucphaithu_chitiet_miengiams
    ) {
      const source = mucphaithu_chitiet.map((x: any) => {
        let obj = { ...x };
        if (obj.sf_hachtoan_congno_id > 0) {
          obj.ten_khoan_nop = obj.sf_hachtoan_congno_noi_dung;
          obj.nhom_khoan_nop = " Quyết toán";
        }
        for (let i = 0; i < sf_mucphaithu_miengiams.length; i++) {
          const fieldName =
            "M_" + sf_mucphaithu_miengiams[i].sf_hinhthucmiengiam_id;
          const _sf_mucphaithu_chitiet_miengiam =
            sf_mucphaithu_chitiet_miengiams.find(
              (y) =>
                y.sf_mucphaithu_chitiet_id == x.id &&
                y.sf_hinhthucmiengiam_id ==
                  sf_mucphaithu_miengiams[i].sf_hinhthucmiengiam_id
            );

          if (_sf_mucphaithu_chitiet_miengiam) {
            obj = {
              ...obj,
              [fieldName]: _sf_mucphaithu_chitiet_miengiam.so_tien_mien_giam,
            };
          }
        }
        return obj;
      });
      return source;
    }
    return [];
  }, [
    mucphaithu_chitiet,
    sf_mucphaithu_miengiams,
    sf_mucphaithu_chitiet_miengiams,
  ]);

  // DataSource cho DataTable (có collapse)
  const dataSource = useMemo(() => {
    if (rawDataSource.length === 0) return [];

    // Group data by nhom_khoan_nop
    const groupedData: Record<string, any[]> = {};
    rawDataSource.forEach((item: any) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      if (!groupedData[groupKey]) {
        groupedData[groupKey] = [];
      }
      groupedData[groupKey].push(item);
    });

    // Flatten data with group headers
    const result: any[] = [];
    Object.keys(groupedData).forEach((groupKey: string) => {
      // Add group header row
      result.push({
        id: `group_${groupKey}`,
        isGroupHeader: true,
        nhom_khoan_nop: groupKey,
        ma_khoan_nop: "",
        ten_khoan_nop: `Nhóm: ${groupKey}`,
        groupItems: groupedData[groupKey],
        isExpanded: expandedGroups.has(groupKey),
      });

      // Chỉ add group items nếu group được expand
      if (expandedGroups.has(groupKey)) {
        groupedData[groupKey].forEach((item: any) => {
          result.push({
            ...item,
            isGroupHeader: false,
            parentGroup: groupKey,
          });
        });
      }
    });

    return result;
  }, [rawDataSource, expandedGroups]);

  // DataSource đầy đủ cho ThuPhiThongTinTongHop (không collapse)
  const fullDataSource = useMemo(() => {
    return rawDataSource;
  }, [rawDataSource]);

  // Tự động expand tất cả groups khi có dữ liệu
  useEffect(() => {
    if (rawDataSource.length > 0) {
      const newExpandedGroups = new Map<string, string>();
      const uniqueGroups = new Set<string>();
      rawDataSource.forEach((item: any) => {
        const groupKey = item.nhom_khoan_nop || "Khác";
        uniqueGroups.add(groupKey);
      });
      uniqueGroups.forEach((groupKey) => {
        newExpandedGroups.set(groupKey, groupKey);
      });
      setExpandedGroups(newExpandedGroups);
    }
  }, [rawDataSource]);

  const toggleGroup = useCallback((groupKey: string) => {
    setExpandedGroups((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(groupKey)) {
        newMap.delete(groupKey);
      } else {
        newMap.set(groupKey, groupKey);
      }
      return newMap;
    });
  }, []);
  useEffect(() => {
    dispatch(
      initialThuPhiChiTietState({
        ...state,
        sf_mucphaithu: props.sf_mucphaithu,
      })
    );
  }, [props.sf_mucphaithu.id]);
  useEffect(() => {
    handleReload();
  }, [props.sf_mucphaithu.id]);
  useEffect(() => {
    if (status === PageBaseStatus.is_need_reload)
      dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
  }, [status]);
  const handleReload = () => {
    dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
    dispatch(loadThuPhiMienGiamStart(props.sf_mucphaithu.id));
    dispatch(loadThuPhiPhanBoPhiStart(props.sf_mucphaithu.id));
    dispatch(loadThuPhiChiTietMucPhaiThuStart(props.sf_mucphaithu.id));
  };

  const handleShowDeleteKhoanNopConfirm = (
    sf_mucphaithu_chitiet_viewmodel: sf_mucphaithu_chitiet_viewmodel
  ) => {
    dispatch(showThuPhiDeleteKhoanNopConfirm(sf_mucphaithu_chitiet_viewmodel));
  };
  const handleCloseDeleteKhoanNopConfirm = () => {
    dispatch(closeThuPhiDeleteKhoanNopConfirm());
  };
  const handleSubmitDeleteKhoanNop = () => {
    if (sf_mucphaithu_chitiet_selected) {
      // console.log(sf_mucphaithu_chitiet_selected)
      dispatch(deleteThuPhiKhoanNopStart(sf_mucphaithu_chitiet_selected));
    }
  };

  const onClose = useCallback(() => {
    props.onClose(false);
  }, []);

  const DeleteKhoanNopConfirm = () => {
    if (is_show_confirm_delete && sf_mucphaithu_chitiet_selected) {
      return (
        <DefaultConfirm
          // animationOf={`btnDeleteKhoanNop${sf_mucphaithu_chitiet_selected.id}`}
          type="danger"
          onClose={handleCloseDeleteKhoanNopConfirm}
          onConfirmed={handleSubmitDeleteKhoanNop}
          text="Bạn có chắc chắn muốn bỏ khoản nộp này khỏi chứng từ ?"
          text_close_button="Không bỏ"
          text_confirm_button="Bỏ khoản nộp"
          is_saving={status === PageBaseStatus.is_deleting}
        />
      );
    }
    return <></>;
  };
  const UpdateNgayThu = (so_chung_tu: string) => {
    bienLaiThuApi.update_ngaythu({
      so_chung_tu: so_chung_tu,
      ngay_thu_thuc_te: ngaythu,
    });
    showNotify({ message: "Cập nhật thành công", type: "success" });
  };

  const columns = useMemo((): IColumn[] => {
    const result: IColumn[] = [];

    // Cột Bỏ (nếu không readOnly và không tbtp)
    if (!is_readOnly && !is_tbtp) {
      result.push({
        caption: "Bỏ",
        id: "delete",
        width: 50,
        align: "center",
        fixed: true,
        fixedPosition: "left",
        cellRender: (data: any) => {
          if (data.isGroupHeader) {
            return <span></span>;
          }
          return (
            <div id={`btnDeleteKhoanNop${data.id}`}>
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleShowDeleteKhoanNopConfirm(data);
                }}
              >
                <i aria-hidden="true" className="fas fa-trash cmd-delete"></i>{" "}
              </span>
            </div>
          );
        },
      });
    }

    // Cột Nhóm với expand/collapse
    result.push({
      caption: "Nhóm",
      id: "nhom_khoan_nop",
      dataField: "nhom_khoan_nop",
      width: 150,
      align: "left",
      fixed: true,
      fixedPosition: "left",
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          const groupKey = data.nhom_khoan_nop || "Khác";
          const isExpanded = expandedGroups.has(groupKey);
          return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                aria-label=""
                variant="invisible"
                size="small"
                onClick={() => toggleGroup(groupKey)}
              />
              <Box
                sx={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  marginLeft: "8px",
                  color: "#0969da",
                }}
              >
                Nhóm: {groupKey}
              </Box>
            </Box>
          );
        }
        return <span>{data.nhom_khoan_nop || ""}</span>;
      },
    });

    // Cột Tên khoản nộp (gộp với Mã)
    result.push({
      caption: "Tên khoản nộp",
      id: "ten_khoan_nop",
      dataField: "ten_khoan_nop",
      width: 200,
      fixed: true,
      fixedPosition: "left",
      align: "left",
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{data.ten_khoan_nop || ""}</span>
            {data.ma_khoan_nop && (
              <span
                style={{ fontSize: "0.85em", color: "#6c757d", opacity: 0.7 }}
              >
                {data.ma_khoan_nop}
              </span>
            )}
          </div>
        );
      },
    });

    // Cột Định mức
    result.push({
      caption: "Định mức",
      id: "so_tien_dinh_muc",
      dataField: "so_tien_dinh_muc",
      width: 100,
      align: "right",
      summary: true,
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return <span>{formatVND(data.so_tien_dinh_muc || 0)}</span>;
      },
    });

    // Cột Miễn giảm (nếu có)
    if (sf_mucphaithu_miengiams && sf_mucphaithu_miengiams.length > 0) {
      result.push({
        caption: "Miễn giảm",
        id: "mien_giam",
        align: "center",
        columns: [
          ...sf_mucphaithu_miengiams.map((x) => ({
            caption: x.ma_hinhthucmiengiam,
            id: `M_${x.sf_hinhthucmiengiam_id}`,
            dataField: `M_${x.sf_hinhthucmiengiam_id}`,
            width: 100,
            align: "right" as const,
            summary: true,
            cellRender: (data: any) => {
              if (data.isGroupHeader) {
                return <span></span>;
              }
              return (
                <span>
                  {formatVND(data[`M_${x.sf_hinhthucmiengiam_id}`] || 0)}
                </span>
              );
            },
          })),
          {
            caption: "Tổng",
            id: "so_tien_mien_giam",
            dataField: "so_tien_mien_giam",
            width: 130,
            align: "right" as const,
            summary: true,
            cellRender: (data: any) => {
              if (data.isGroupHeader) {
                return <span></span>;
              }
              return <span>{formatVND(data.so_tien_mien_giam || 0)}</span>;
            },
          },
        ],
      });
    }

    // Cột Phải nộp
    result.push({
      caption: "Phải nộp",
      id: "so_tien_phai_nop",
      dataField: "so_tien_phai_nop",
      width: 100,
      align: "right",
      summary: true,
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return <span>{formatVND(data.so_tien_phai_nop || 0)}</span>;
      },
    });

    // Cột Đã nộp
    result.push({
      caption: "Đã nộp",
      id: "so_tien_da_nop",
      dataField: "so_tien_da_nop",
      width: 100,
      align: "right",
      summary: true,
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return <span>{formatVND(data.so_tien_da_nop || 0)}</span>;
      },
    });

    return result;
  }, [
    is_readOnly,
    is_tbtp,
    expandedGroups,
    toggleGroup,
    sf_mucphaithu_miengiams,
    createUUID,
    handleShowDeleteKhoanNopConfirm,
  ]);

  const summary: ISummary = useMemo(() => {
    const items: any[] = [];

    // Summary cho các cột miễn giảm
    if (sf_mucphaithu_miengiams && sf_mucphaithu_miengiams.length > 0) {
      sf_mucphaithu_miengiams.forEach((x) => {
        items.push({
          name: `M_${x.sf_hinhthucmiengiam_id}`,
          column: `M_${x.sf_hinhthucmiengiam_id}`,
          summaryType: "custom" as const,
          render: (value: number) => formatVND(value),
        });
      });
      items.push({
        name: "so_tien_mien_giam",
        column: "so_tien_mien_giam",
        summaryType: "custom" as const,
        render: (value: number) => formatVND(value),
      });
    }

    // Summary cho các cột khác
    items.push(
      {
        name: "so_tien_dinh_muc",
        column: "so_tien_dinh_muc",
        summaryType: "custom" as const,
        render: (value: number) => formatVND(value),
      },
      {
        name: "so_tien_phai_nop",
        column: "so_tien_phai_nop",
        summaryType: "custom" as const,
        render: (value: number) => formatVND(value),
      },
      {
        name: "so_tien_da_nop",
        column: "so_tien_da_nop",
        summaryType: "custom" as const,
        render: (value: number) => formatVND(value),
      }
    );

    return {
      items,
      calculateCustomSummary: (column: string, data: any[]) => {
        // Tính toán từ rawDataSource (dữ liệu đầy đủ, không bị collapse)
        // Bỏ qua group headers và chỉ tính trên dữ liệu thực
        const realData = rawDataSource.filter((x: any) => !x.isGroupHeader);
        return realData.reduce(
          (sum: number, row: any) => sum + (Number(row[column]) || 0),
          0
        );
      },
    };
  }, [sf_mucphaithu_miengiams, rawDataSource, formatVND]);

  return (
    <React.Fragment>
      <DefaultPopup
        width={"100%"}
        title={
          props.sf_mucphaithu.so_chung_tu +
          ": " +
          (props.sf_mucphaithu.noi_dung || "") +
          " (" +
          (props.ts_hocsinh.ma_hs || "") +
          " - " +
          (props.ts_hocsinh.ho_ten || "") +
          " - " +
          (props.ts_hocsinh.ten_khoi || "") +
          " - " +
          (props.ts_hocsinh.ten_lop + ")" || "")
        }
        onClose={onClose}
      >
        <div>
          {isShowPlaceHolder && <PlaceHolder line_number={20} />}
          {!isShowPlaceHolder && (
            <div>
              <div className="pop-up-form">
                <div className="row">
                  <div
                    className="col-md-12"
                    style={{ width: "calc(100% - 14px)" }}
                  >
                    <div className="thu-phi-toolbar-container">
                      {sf_phanbophis && sf_phanbophis.length > 0 && (
                        <div className="thu-phi-info-row">
                          <div className="thu-phi-payment-info">
                            <span>
                              <b>Hình thức thu phí: </b>
                            </span>
                            {sf_phanbophis.map((x, index) => (
                              <React.Fragment key={index}>
                                <span>{x.hinh_thuc_thanh_toan} : </span>
                                <span
                                  style={{
                                    color: "#0066cc",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {x.so_tien.toLocaleString()};
                                </span>
                                {index < sf_phanbophis.length - 1 && (
                                  <span> </span>
                                )}
                              </React.Fragment>
                            ))}
                          </div>

                          <div className="thu-phi-status-info">
                            {mucphaithu?.tong_tien_phai_nop !== undefined &&
                              mucphaithu?.tong_tien_da_nop !== undefined && (
                                <>
                                  {mucphaithu.tong_tien_phai_nop -
                                    mucphaithu.tong_tien_da_nop -
                                    mucphaithu.tong_tien_tra_truoc !==
                                  0 ? (
                                    <span>
                                      <b>
                                        {mucphaithu.tong_tien_phai_nop -
                                          mucphaithu.tong_tien_da_nop <
                                        0
                                          ? "Thu dư: "
                                          : "Thu thiếu: "}
                                      </b>
                                      <span
                                        style={{
                                          color: "#0066cc",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        {Math.abs(
                                          mucphaithu.so_chung_tu.includes("RV")
                                            ? mucphaithu.tong_tien_phai_nop +
                                                mucphaithu.tong_tien_da_nop
                                            : mucphaithu.tong_tien_phai_nop -
                                                mucphaithu.tong_tien_da_nop -
                                                mucphaithu.tong_tien_tra_truoc
                                        ).toLocaleString()}
                                        ;
                                      </span>
                                    </span>
                                  ) : (
                                    <span>
                                      <b>Thu dư: </b>
                                      <span
                                        style={{
                                          color: "#0066cc",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        0;
                                      </span>
                                      <b> Thu thiếu: </b>
                                      <span
                                        style={{
                                          color: "#0066cc",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        0;
                                      </span>
                                    </span>
                                  )}
                                </>
                              )}
                          </div>

                          <div className="thu-phi-toolbar-info">
                            <span>Khả dụng:</span>
                            <span
                              style={{
                                color: "green",
                                fontWeight: "bold",
                                marginLeft: 5,
                                marginRight: 5,
                              }}
                            >
                              {(
                                tong_tien_thua - tong_tien_da_nop_custom
                              ).toLocaleString()}
                            </span>
                            <span>VNĐ</span>
                          </div>
                        </div>
                      )}

                      {/* Dòng 1 - Buttons chính */}
                      <div className="thu-phi-toolbar-row">
                        <div className="thu-phi-toolbar-buttons">
                          <ThuPhiAddKhoanNopBtn
                            disabled={
                              (bienlaithu !== undefined &&
                                bienlaithu.length > 0) ||
                              is_readOnly ||
                              // isThuPhiTemp ||
                              is_tbtp ||
                              is_khoanno ||
                              (sf_phanbophis !== null &&
                                sf_phanbophis !== undefined &&
                                sf_phanbophis.length > 0 &&
                                sf_phanbophis[0]?.so_chung_tu !== null &&
                                sf_phanbophis[0]?.so_chung_tu !== undefined &&
                                sf_phanbophis[0]?.so_chung_tu.length > 0)
                            }
                            filter={{
                              nam_hoc: props.nam_hoc,
                              dm_he_id: props.ts_hocsinh.dm_he_id,
                              dm_truong_id: props.ts_hocsinh.dm_truong_id,
                              dm_khoi_id: props.ts_hocsinh.dm_khoi_id,
                            }}
                            nam_hoc={props.nam_hoc}
                            sf_mucphaithu={props.sf_mucphaithu}
                            ts_hocsinh_id={props.ts_hocsinh.id}
                            sf_khoannop_ids_added={dataSource.map(
                              (x: any) => x.sf_khoannop_id
                            )}
                            onChanged={() => {
                              dispatch(
                                loadThuPhiChiTietStart(props.sf_mucphaithu.id)
                              );
                              loadMucPhaiThu();
                            }}
                          />

                          {/* <ThuPhiHinhThucThuPhiBtn
                            disabled={
                              isHideDatbox ||
                              false ||
                              props.sf_mucphaithu.sf_hachtoan_congno_id > 0 ||
                              props.sf_mucphaithu.so_chung_tu.includes("RV") ||
                              (bienlaithu !== undefined &&
                                bienlaithu.length > 0)
                            }
                            sf_mucphaithu={mucphaithu || props.sf_mucphaithu}
                            sf_bienlaithu={bienlaithu}
                            ts_hocsinh={props.ts_hocsinh}
                            onChanged={() => {
                              dispatch(
                                loadThuPhiPhanBoPhiStart(props.sf_mucphaithu.id)
                              );
                              handleReload();
                              loadMucPhaiThu();
                            }}
                          /> */}

                          <HoanPhiQuyetToanBtn
                            disabled={
                              (bienlaithu !== undefined &&
                                bienlaithu.length > 0) ||
                              is_readOnly ||
                              // isThuPhiTemp ||
                              is_tbtp ||
                              (sf_phanbophis !== null &&
                                sf_phanbophis !== undefined &&
                                sf_phanbophis.length > 0 &&
                                sf_phanbophis[0]?.so_chung_tu !== null &&
                                sf_phanbophis[0]?.so_chung_tu !== undefined &&
                                sf_phanbophis[0]?.so_chung_tu.length > 0)
                            }
                            sf_mucphaithu={props.sf_mucphaithu}
                            onChanged={() => {
                              dispatch(
                                loadThuPhiMienGiamStart(props.sf_mucphaithu.id)
                              );
                              dispatch(
                                loadThuPhiChiTietStart(props.sf_mucphaithu.id)
                              );
                              loadMucPhaiThu();
                            }}
                          />
                          <ThuPhiDieuChinhChietKhauBtn
                            sf_mucphaithu={props.sf_mucphaithu}
                            disabled={
                              (bienlaithu !== undefined &&
                                bienlaithu.length > 0) ||
                              is_readOnly ||
                              false
                            }
                            onChanged={() => {
                              dispatch(
                                loadThuPhiMienGiamStart(props.sf_mucphaithu.id)
                              );
                              dispatch(
                                loadThuPhiChiTietStart(props.sf_mucphaithu.id)
                              );
                              loadMucPhaiThu();
                            }}
                            ts_hocsinh={props.ts_hocsinh}
                          />
                          <ThuPhiFinishConfirmBtn
                            disabled={
                              (bienlaithu !== undefined &&
                                bienlaithu.length > 0) ||
                              !sf_phanbophis ||
                              sf_phanbophis.length === 0 ||
                              !sf_phanbophis[0]?.hinh_thuc_thanh_toan
                            }
                            sf_mucphaithu={props.sf_mucphaithu}
                            ts_hocsinh={props.ts_hocsinh}
                            onChanged={() => {
                              setIsLoadBienLai(true);
                              dispatch(
                                loadThuPhiChiTietMucPhaiThuStart(
                                  props.sf_mucphaithu.id
                                )
                              );
                              loadMucPhaiThuChiTiet();
                            }}
                            ngaythu={ngaythu}
                            nam_hoc_dong_phi={namhoc_dongphi}
                          />

                          {!props.sf_mucphaithu.so_chung_tu.includes("RV") && (
                            <ThuPhiTaoBienLaiBtn
                              disabled={
                                bienlaithu === undefined ||
                                (bienlaithu !== undefined &&
                                  bienlaithu.length === 0) ||
                                props.sf_mucphaithu.sf_hachtoan_congno_id > 0 ||
                                props.sf_mucphaithu.so_chung_tu.includes("RV")
                              }
                              sf_mucphaithu={props.sf_mucphaithu}
                            />
                          )}

                          <ThuPhiSendBienLaiBtn
                            disabled={
                              bienlaithu === undefined ||
                              (bienlaithu !== undefined &&
                                bienlaithu.length === 0) ||
                              false ||
                              props.sf_mucphaithu.sf_hachtoan_congno_id > 0 ||
                              props.sf_mucphaithu.so_chung_tu.includes("RV")
                            }
                            sf_mucphaithu={props.sf_mucphaithu}
                            ts_hocsinh_id={props.ts_hocsinh.id}
                          />

                          {sf_mucphaithu &&
                            sf_mucphaithu.sf_mucphaithu_root_id === 0 &&
                            isAccessibleDelete && (
                              <ThuPhiHuyChungTuBtn
                                disabled={
                                  false ||
                                  props.sf_mucphaithu.sf_hachtoan_congno_id >
                                    0 ||
                                  props.sf_mucphaithu.so_chung_tu.includes(
                                    "NO"
                                  ) ||
                                  props.sf_mucphaithu.so_chung_tu.includes("RV")
                                }
                                sf_mucphaithu_id={props.sf_mucphaithu.id}
                                onChanged={() => {
                                  props.onClose(true);
                                }}
                              />
                            )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      width: "calc(100% - 16px)",
                      marginLeft: "8px",
                      marginRight: "8px",
                    }}
                  >
                    <div style={{ flex: "1 1 65%", minWidth: 0 }}>
                      <DataTable
                        data={dataSource}
                        columns={columns}
                        height={`${window.innerHeight - 320}px`}
                        paging={{ enable: false }}
                        summary={summary}
                      />
                    </div>
                    <div style={{ flex: "1 1 35%", minWidth: 0 }}>
                      <ThuPhiThongTinTongHop
                        sf_mucphaithu={mucphaithu || props.sf_mucphaithu}
                        ts_hocsinh={props.ts_hocsinh}
                        sf_phanbophis={sf_phanbophis}
                        dataSource={fullDataSource}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <ModalActions>
                <Button
                  variant="default"
                  leadingVisual={XIcon}
                  text="Đóng"
                  onClick={onClose}
                />
              </ModalActions>
              <DeleteKhoanNopConfirm />
            </div>
          )}
        </div>
      </DefaultPopup>
    </React.Fragment>
  );
};
export default ThuPhiChiTiet;
